import {SpanIcon} from '@mazraeapp/react_icon_kit';

export type NotificationCategoryType =
  | 'All'
  | 'order_and_buy'
  | 'loan_and_credit'
  | 'shop'
  | 'advertisement'
  | 'other';

export interface NotificationCategoryItem {
  engTittle: NotificationCategoryType;
  title: string;
  icon: React.ReactNode;
}

export const notificationCategoryItems: NotificationCategoryItem[] = [
  {
    engTittle: 'All',
    title: 'همه',
    icon: (
      <SpanIcon className="text-base leading-4 text-gray-700 icon-nameCheckmark " />
    ),
  },
  {
    engTittle: 'order_and_buy',
    title: 'سفارش و خرید',
    icon: (
      <SpanIcon className="text-base leading-4 text-gray-700 icon-nameShopping-bag-time " />
    ),
  },
  {
    engTittle: 'shop',
    title: 'فروشگاه',
    icon: (
      <SpanIcon className="text-base leading-4 text-gray-700 icon-nameStore " />
    ),
  },
  {
    engTittle: 'loan_and_credit',
    title: 'وام و اعتبار',
    icon: (
      <SpanIcon className="text-base leading-4 text-gray-700 icon-styleoutline157" />
    ),
  },
  {
    engTittle: 'advertisement',
    title: 'آگهی',
    icon: (
      <SpanIcon className="text-base leading-4 text-gray-700 icon-Report-List " />
    ),
  },
  {
    engTittle: 'other',
    title: 'سایر',
    icon: (
      <SpanIcon className="text-base leading-4 text-gray-700 icon-nameHamburger-menu " />
    ),
  },
];
